module.exports = __webpack_public_path__ + "img/img27.1ec71855.png";